module.exports = " <h6>Je gebruikt een verouderde browser!</h6> <p>Update je browser om deze website correct te bekijken. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/nl>Update mijn browser nu </a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Sluiten>&times;</a></p> ";


//////////////////
// WEBPACK FOOTER
// ./outdated-browser/lang/nl.html
// module id = 825
// module chunks = 2